// 单独封装 默认导出
import { createBrowserHistory } from "history"
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom"

// import { useHistory } from "react-router-dom"
const history = createBrowserHistory()
// const history = useHistory()
export { HistoryRouter, history }
